module.exports = __webpack_public_path__ + "img/userInfo.db95fdec.png";